import { Colors } from '../../consts/Colors';
export default class Card2 extends Phaser.GameObjects.Container {
    constructor(scene, x, y, cardData, deck) {
        super(scene, x, y, []);

        scene.add.existing(this);
        this.initPosition = { x: x, y: y }
        this.scene = scene;
        this.isDone = false;
        this.img = cardData.image + "Noir"
        this.imgCorrect = cardData.image
        this.zoneId = cardData.zoneId;
        this.correct = cardData.correct
        this.incorrect = cardData.incorrect
        this.titre = cardData.titre
        this.index = cardData.index
        this.cardData = cardData
        this.isFirstDrop = true

        this.scaleInit = 0.7

        this.deck = deck

        this.cardImage = this.scene.add.image(0, 0, this.img).setOrigin(0.5);
        this.add(this.cardImage);

        this.rect = this.scene.add.rectangle(0, 0, this.cardImage.width, this.cardImage.height, Colors.Elmt.Blue, 0).setOrigin(0.5);
        // this.rect.setStrokeStyle(8, Colors.Elmt.Orange, 1);
        this.add(this.rect);

        this.setSize(this.cardImage.width, this.cardImage.height);
        this.setInteractive({ useHandCursor: true });
        this.scene.input.setDraggable(this)
        this.setScale(this.scaleInit)
    }

    drop(pointer, gameObject, dropZone) {
        if(gameObject.zoneId !== dropZone.zoneId) {
            this.setFalse()
            dropZone.setWrong()
            this.deck.setDeckFalse(this.incorrect[dropZone.zoneId])
            if (gameObject.isFirstDrop === true) {
                this.scene.game.data.score.mauvais++
                gameObject.isFirstDrop = false
            }
            this.rect.setStrokeStyle(8, Colors.Elmt.Red, 1);
            gameObject.disableInteractive()
            // gameObject.resetPosition(this.scaleInit)
            return
        }

        dropZone.dropZone.setTint(0xFFFFFF);
        let zone = this.scene.getZoneByCarteIndex(gameObject.index)
        
        let moveX = zone.x - gameObject.parentContainer.x
        let moveY = zone.y - gameObject.parentContainer.y

        zone.setCorrect()
        zone.disableInteractive()
        this.rect.setStrokeStyle(8, Colors.Elmt.Green, 1);
        this.rect.setAlpha(1)
        this.deck.setDeckTrue(this.correct)
        if (gameObject.isFirstDrop === true) {
            this.scene.game.data.score.bravo++
            gameObject.isFirstDrop = false
        }

        gameObject.disableInteractive()

        this.scene.tweens.add({
            delay: 100,
            targets: gameObject,
            duration: 300,
            x: moveX,
            y: moveY,
            scale: 0.4,
            onComplete: () => {
                this.setAlpha(1)
                // this.setScale(1)
                this.cardImage.setTexture(this.imgCorrect)
                // this.rect.setAlpha(0)
                zone.dropZone.setTint(0xFFFFFF);
            }
        })
    }

    dragEnd(pointer, gameObject, dropped) {
        if (!dropped) {
            gameObject.resetPosition(this.scaleInit)
        }
    }


    onDrag() {
        this.setScale(0.5)
        this.rect.setAlpha(0)
        this.deck.hideDeckInfos()
    }

    setDone() {
        this.isDone = true
    }

    setFalse(){
        this.rect.setAlpha(1)
        this.scene.tweens.add({
            targets: this.rect,
            duration: 400,
            alpha: 0,
            yoyo: true,
            repeat: 4,
        })
        this.rect.setStrokeStyle(8, Colors.Elmt.Red, 1);
    }

    setNormal(){
        this.rect.setAlpha(0)
        this.rect.setStrokeStyle(0, Colors.Elmt.Blue, 0);
    }

    resetPosition(scale = 1, duration = 300 ) {
        this.scene.tweens.killTweensOf(this.rect)
        this.setNormal()
        this.scene.tweens.add({
            targets: this,
            duration: duration,
            x: this.initPosition.x,
            y: this.initPosition.y - 20,
            scale: scale,
            onComplete: () => {
                this.setInteractive({ useHandCursor: true })
            }
        })
    }
}